import { DragEvent, FC, useCallback } from "react"
import {
  useImportCsvMutation,
  useFetchBrandsQuery
} from "../../../redux/queries"
import DropZone from "../drop-zone"
import LOsTable from "./table"
import ImportMembersModal from "../import-members-modal"
import { useAppSelector, useIsAdmin } from "../../hooks"
import { selectUserDetails } from "../../../redux/slices/auth"
import { LoSearchParams } from "../../../types"

interface Props {
  searchParams: LoSearchParams
  onClickLO?: (loID: string) => void
  hasNewButton?: boolean
  hasViewTypeToggle?: boolean
  hasMasqueradeIcon?: boolean
}

const TableWithImporter: FC<Props> = ({
  searchParams,
  onClickLO,
  hasViewTypeToggle = false,
  hasNewButton = false,
  hasMasqueradeIcon = false
}) => {
  const user = useAppSelector(selectUserDetails)

  const [importCsv, { data: importCsvResponse, reset }] = useImportCsvMutation()

  const { data: brands } = useFetchBrandsQuery(
    { org_id: user?.org?.id },
    { skip: !user?.org?.id }
  )

  const isAdmin = useIsAdmin()

  const onDropFile = useCallback(
    (e: DragEvent<HTMLDivElement>) => {
      const file = e.dataTransfer.files[0]
      importCsv(file)
    },
    [importCsv]
  )

  return (
    <div className="bg-white">
      <DropZone onDrop={onDropFile} dropZoneEnabled={isAdmin}>
        <LOsTable
          searchParams={searchParams}
          hasNewButton={hasNewButton}
          hasViewTypeToggle={hasViewTypeToggle}
          hasMasqueradeIcon={isAdmin && hasMasqueradeIcon}
          {...(onClickLO && { onClickLO })}
        />
      </DropZone>

      {isAdmin && (
        <ImportMembersModal
          show={!!importCsvResponse?.length}
          rows={importCsvResponse ?? []}
          brands={brands ?? []}
          onClose={reset}
        />
      )}
    </div>
  )
}

export default TableWithImporter
